export enum ACTIONS {
  UPD_LOADING_STATUS = 'UPD_LOADING_STATUS',
}
